namespace RioERP.Enquiry {
    export interface PendingOrdersRow {
        Id?: number;
        NopOrderId?: number;
        CustomerId?: number;
        HandledBy?: number;
        OrderStatus?: Web.Enums.PendingOrderStatus;
        OrderDate?: string;
        CustomerName?: string;
        Mobile?: string;
        Email?: string;
        Address?: string;
        City?: string;
        StateId?: number;
        Pincode?: number;
        IsActive?: boolean;
        OrderProducts?: number[];
        UserUsername?: string;
        StateName?: string;
        StateIsActive?: boolean;
        StateInsertUserId?: number;
        StateInsertDate?: string;
        StateUpdateUserId?: number;
        StateUpdateDate?: string;
        StateIsHomeState?: boolean;
        InsertUserId?: number;
        InsertDate?: string;
        UpdateUserId?: number;
        UpdateDate?: string;
    }

    export namespace PendingOrdersRow {
        export const idProperty = 'Id';
        export const nameProperty = 'CustomerName';
        export const localTextPrefix = 'Enquiry.PendingOrders';
        export const lookupKey = 'Enquiry.PendingOrders';

        export function getLookup(): Q.Lookup<PendingOrdersRow> {
            return Q.getLookup<PendingOrdersRow>('Enquiry.PendingOrders');
        }
        export const deletePermission = 'Enquiry:EnquiryManagement:Modify';
        export const insertPermission = 'Enquiry:EnquiryManagement:Modify';
        export const readPermission = 'Enquiry:EnquiryManagement:View';
        export const updatePermission = 'Enquiry:EnquiryManagement:Modify';

        export declare const enum Fields {
            Id = "Id",
            NopOrderId = "NopOrderId",
            CustomerId = "CustomerId",
            HandledBy = "HandledBy",
            OrderStatus = "OrderStatus",
            OrderDate = "OrderDate",
            CustomerName = "CustomerName",
            Mobile = "Mobile",
            Email = "Email",
            Address = "Address",
            City = "City",
            StateId = "StateId",
            Pincode = "Pincode",
            IsActive = "IsActive",
            OrderProducts = "OrderProducts",
            UserUsername = "UserUsername",
            StateName = "StateName",
            StateIsActive = "StateIsActive",
            StateInsertUserId = "StateInsertUserId",
            StateInsertDate = "StateInsertDate",
            StateUpdateUserId = "StateUpdateUserId",
            StateUpdateDate = "StateUpdateDate",
            StateIsHomeState = "StateIsHomeState",
            InsertUserId = "InsertUserId",
            InsertDate = "InsertDate",
            UpdateUserId = "UpdateUserId",
            UpdateDate = "UpdateDate"
        }
    }
}
